/**
 * @description 套印要保書類型
 */
export enum ExpType {
  /** 全部 */
  All = '0',
  /** 僅要保書 + 名冊 */
  OnlyRequire = '1',
  /** 僅 KYC */
  OnlyKyc = '2'
}
